import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
import "regenerator-runtime/runtime.js";
import { parseConfigPosition, parseCurrentViewFilters, parseFieldsResult, parseFilter, parseViewsConfigs } from "@/app-search/helpers/app-search.helpers";
import OrderModule from "@/store/modules/order";
import UserModule from "@/store/modules/user";
import { computed, defineComponent, ref, watch } from "vue";
import completedTableConfig from "@/app-search/tables/attendee-completed-orders-config.json";
import completedViewConfig from "@/app-search/filters/attendee-completed-orders-view-config.json";
import pendingTableConfig from "@/app-search/tables/attendee-pending-bookings-config.json";
import pendingViewConfig from "@/app-search/filters/attendee-not-paid-bookings-view-config.json";
import allOrdersViewConfig from "@/app-search/filters/attendee-all-orders-view-config.json";
import _cloneDeep from "lodash/cloneDeep";
import { ModalStatus } from "@/constants/modal";
import { dialogVisibleForStatus } from "@/utils/vue-helpers/modal";
import { BookingStateString } from "@/types/db/product-slot-booking";
import { useI18n } from "vue-i18n";
import { setOrderManagementTokens } from "@/utils/helpers/auth";
import { B2B_IFRAME_URL } from "@/constants/env";
import { LogService } from "@/services/logging";
import { getElementsByQuery } from "@/utils/helpers/dom";
import closeIcon from "@/assets/images/svg/close.svg";
import editPen from "@/assets/images/svg/edit-pen-rectangle.svg";
import leftArrowIcon from "@/assets/images/svg/left-arrow.svg";
import NotificationService from "@/services/notification.service";
import { cloneDeep } from "lodash";
import { BookingPaymentOptions } from "@/constants/booking";
import POSConfigModule from "@/store/modules/pos-config";
import { formatDateTimeOrders } from "@/utils/helpers/dates";
import { BookingTeamsStatus } from "@/interfaces/teams/teams";
import { BookingStatus } from "@/types/db/product-slot-state";
import { sumArray } from "@/utils/helpers/common";
import { ElasticsearchAccessError } from "@/constants/errors/elasticsearch";
import dayjs from "dayjs";
import { DatePeriod, OptionTypes, SortingDirections } from "@/app-search/enums/enums";
import { SetUp, Delete, CaretTop, CaretBottom, Setting } from "@element-plus/icons-vue";
import { getGroupDayJsDateFormat } from "@/utils/helpers/dates";
import { getAddons } from "@/api/gql/product-slot-state";
import { OrderTableColumns } from "@/interfaces/store/IOrder";
import { selectOrderForEditing, close } from "@/utils/vue-helpers/orders";
import { selectBooking } from "@/utils/vue-helpers/booking";
import { DrawerModes } from "@/constants/drawer";
import BookingModule from "@/store/modules/booking";
export default defineComponent({
  name: "Orders",
  components: {},
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
      var _dateFilter$value, _dateFilter$value2, _dateFilter$value3, _dateFilter$value4, _dateFilter$value5, _dateFilter$value6, _dateFilter$value7;

      var editIconStyle, editIconContent, editIconAlt, closeIconStyle, closeIconContent, closeIconAlt, leftArrowIconStyle, leftArrowIconContent, leftArrowIconAlt, _useI18n, t, dialogVisible, bookingsPaymentFilter, query, pageSize, currentPage, bookingReferenceQuery, filter, isOrderSelected, isOrderViewLoaded, selectedOrderId, selectedBookingRef, frameSource, frameHeight, drawerVisible, drawerMode, isFilterApplied, dateFilter, dateFilterType, selectedSortingOption, selectedSortingDirection, startDate, startTime, startDate2, startTime2, dateFilterTypeOptions, dateShortcuts, selectedDateShortcut, isApllyFilterButtonEnabled, afterNowFilter, isFilterLoading, showTicketsListModal, ticketsList, showRetailsListModal, retailsList, addonsList, isFetchingAddons, orderAddonsList, showAddonsListModal, resultedBookings, parsedOrders, ordersCount, orderTableConfig, orderTableConfigCopy, allColumnsEnabled, isIndeterminate, handleAllColumnsChange, _getViewConfig, pinnedViewId, viewId, getViewConfig, setSortingDirection, updateBookingsPaymentFilter, _updateBookingsPaymentFilter, viewFilters, _viewFilters, getCurrentViewFilters, _getCurrentViewFilters, tableConfig, getTableConfig, getFilter, _getFilter, queryOrders, columns, changeCurrentPage, formattedDate, groupId, goBack, showTeamsColumn, updateDateFilter, _updateDateFilter, toggleDrawer, clearDateFilter, _clearDateFilter, getOrders, _getOrders, fetchAddons, _fetchAddons, isDateIncludedInFilter, isColumnEnabled, updateOrderTableSettings;

      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              updateOrderTableSettings = function _updateOrderTableSett() {
                OrderModule.setTableConfig(orderTableConfigCopy.value);
                drawerVisible.value = false;
              };

              isColumnEnabled = function _isColumnEnabled(id) {
                var column = OrderModule.orderTableConfig.find(function (c) {
                  return c.id === id;
                });
                return column && column.enabled;
              };

              isDateIncludedInFilter = function _isDateIncludedInFilt(dateString) {
                var _dateFilter$value8;

                var params = (_dateFilter$value8 = dateFilter.value) === null || _dateFilter$value8 === void 0 ? void 0 : _dateFilter$value8.params;
                if (!params) return true;
                var date = dayjs(dateString).utc();

                if (params.from && params.to) {
                  return date.isSameOrAfter(dayjs(params.from).utc()) && date.isSameOrBefore(dayjs(params.to).utc());
                } else if (params.from) {
                  return date.isSameOrAfter(dayjs(params.from).utc());
                } else if (params.to) {
                  date.isSameOrBefore(dayjs(params.to).utc());
                }

                return true;
              };

              _fetchAddons = function _fetchAddons3() {
                _fetchAddons = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                  var ids, addons, res, _iterator4, _step4, _loop2, _ret2;

                  return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                      switch (_context15.prev = _context15.next) {
                        case 0:
                          isFetchingAddons.value = true;
                          ids = OrderModule.getParsedOrders.map(function (data) {
                            return String(data.id);
                          });
                          addonsList.value = {};
                          addons = addonsList.value;
                          _context15.prev = 4;
                          _context15.next = 7;
                          return getAddons(ids);

                        case 7:
                          res = _context15.sent;
                          _iterator4 = _createForOfIteratorHelper(res);
                          _context15.prev = 9;

                          _loop2 = function _loop2() {
                            var addon = _step4.value;
                            if (!addon || !addon.bookingId || !(addon !== null && addon !== void 0 && addon.categoryName)) return "continue";

                            if (!addons[addon.bookingId]) {
                              addons[addon.bookingId] = [];
                            }

                            var index = addons[addon.bookingId].findIndex(function (item) {
                              return item.name === addon.categoryName;
                            });

                            if (index !== -1) {
                              // increment quantity
                              addons[addon.bookingId][index].quantity += 1;
                              return "continue";
                            }

                            addons[addon.bookingId].push({
                              name: addon.categoryName,
                              quantity: 1
                            });
                          };

                          _iterator4.s();

                        case 12:
                          if ((_step4 = _iterator4.n()).done) {
                            _context15.next = 18;
                            break;
                          }

                          _ret2 = _loop2();

                          if (!(_ret2 === "continue")) {
                            _context15.next = 16;
                            break;
                          }

                          return _context15.abrupt("continue", 16);

                        case 16:
                          _context15.next = 12;
                          break;

                        case 18:
                          _context15.next = 23;
                          break;

                        case 20:
                          _context15.prev = 20;
                          _context15.t0 = _context15["catch"](9);

                          _iterator4.e(_context15.t0);

                        case 23:
                          _context15.prev = 23;

                          _iterator4.f();

                          return _context15.finish(23);

                        case 26:
                          _context15.next = 31;
                          break;

                        case 28:
                          _context15.prev = 28;
                          _context15.t1 = _context15["catch"](4);
                          console.log(_context15.t1);

                        case 31:
                          isFetchingAddons.value = false;

                        case 32:
                        case "end":
                          return _context15.stop();
                      }
                    }
                  }, _callee15, null, [[4, 28], [9, 20, 23, 26]]);
                }));
                return _fetchAddons.apply(this, arguments);
              };

              fetchAddons = function _fetchAddons2() {
                return _fetchAddons.apply(this, arguments);
              };

              _getOrders = function _getOrders3() {
                _getOrders = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                  var _OrderModule$dateOfVi, parsedFilter, dateOfVisitParams;

                  return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                      switch (_context14.prev = _context14.next) {
                        case 0:
                          _context14.prev = 0;
                          parsedFilter = parseFilter(filter.value); // if there's a date filter applied, we add it to the bookingEngine request options

                          dateOfVisitParams = (_OrderModule$dateOfVi = OrderModule.dateOfVisitFilter) === null || _OrderModule$dateOfVi === void 0 ? void 0 : _OrderModule$dateOfVi.params;

                          if (dateOfVisitParams) {
                            parsedFilter.options.filters.all = [].concat(_toConsumableArray(parsedFilter.options.filters.all), [{
                              booking_first_start_date: dateOfVisitParams
                            }]);
                          }

                          _context14.next = 6;
                          return OrderModule.fetchBooking(parsedFilter);

                        case 6:
                          fetchAddons();
                          _context14.next = 18;
                          break;

                        case 9:
                          _context14.prev = 9;
                          _context14.t0 = _context14["catch"](0);

                          if (!(_context14.t0 instanceof ElasticsearchAccessError)) {
                            _context14.next = 14;
                            break;
                          }

                          NotificationService.showCustomError(t("error.insufficient-permissions"));
                          return _context14.abrupt("return");

                        case 14:
                          if (!/Page contains invalid option: (\S+); must be less than or equal to (\d+)/.test(String(_context14.t0))) {
                            _context14.next = 17;
                            break;
                          }

                          NotificationService.showCustomMessage(t("error.app-search-pagination-limit"), "warning"); // No need to throw this error to syntry

                          return _context14.abrupt("return");

                        case 17:
                          throw new Error(_context14.t0);

                        case 18:
                        case "end":
                          return _context14.stop();
                      }
                    }
                  }, _callee14, null, [[0, 9]]);
                }));
                return _getOrders.apply(this, arguments);
              };

              getOrders = function _getOrders2() {
                return _getOrders.apply(this, arguments);
              };

              _clearDateFilter = function _clearDateFilter3() {
                _clearDateFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                  return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          OrderModule.setDateOfVisitFilter(null);
                          OrderModule.setTickets([]);
                          _context13.next = 4;
                          return getOrders();

                        case 4:
                        case "end":
                          return _context13.stop();
                      }
                    }
                  }, _callee13);
                }));
                return _clearDateFilter.apply(this, arguments);
              };

              clearDateFilter = function _clearDateFilter2() {
                return _clearDateFilter.apply(this, arguments);
              };

              toggleDrawer = function _toggleDrawer(mode) {
                drawerMode.value = mode;

                if (mode === DrawerModes.Settings) {
                  orderTableConfigCopy.value = cloneDeep(_toConsumableArray(OrderModule.orderTableConfig));
                }

                drawerVisible.value = true;
              };

              _updateDateFilter = function _updateDateFilter3() {
                _updateDateFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                  var params, start, end, from, to, _startTime$value$spli, _startTime$value$spli2, h, m, date1, _end, _startTime2$value$spl, _startTime2$value$spl2, h2, m2, date2;

                  return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                      switch (_context12.prev = _context12.next) {
                        case 0:
                          isFilterLoading.value = true;
                          params = null;

                          if (dateFilterType.value === OptionTypes.DateIs) {
                            start = dayjs().startOf("day");

                            if (selectedDateShortcut.value === DatePeriod.Yesterday) {
                              start = start.subtract(1, "day");
                            } else if (selectedDateShortcut.value === DatePeriod.Tomorrow) {
                              start = start.add(1, "day");
                            }

                            end = start.add(1, "day");
                            from = start.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]");
                            to = end.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]");
                            params = {
                              from: from,
                              to: to
                            };
                          } else if (dateFilterType.value === OptionTypes.DateAfter && afterNowFilter.value) {
                            params = {
                              from: dayjs().utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]")
                            };
                          } else {
                            _startTime$value$spli = startTime.value.split(":"), _startTime$value$spli2 = _slicedToArray(_startTime$value$spli, 2), h = _startTime$value$spli2[0], m = _startTime$value$spli2[1];
                            date1 = dayjs(startDate.value).set("hour", Number(h)).set("minute", Number(m)).set("second", 0);

                            if (dateFilterType.value === OptionTypes.DateEqualTo) {
                              _end = date1.add(1, "minute");
                              params = {
                                from: date1.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                                to: _end.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]")
                              };
                            } else if (dateFilterType.value === OptionTypes.DateBefore) {
                              params = {
                                to: date1.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]")
                              };
                            } else if (dateFilterType.value === OptionTypes.DateAfter) {
                              params = {
                                from: date1.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]")
                              };
                            } else {
                              _startTime2$value$spl = startTime2.value.split(":"), _startTime2$value$spl2 = _slicedToArray(_startTime2$value$spl, 2), h2 = _startTime2$value$spl2[0], m2 = _startTime2$value$spl2[1];
                              date2 = dayjs(startDate2.value).set("hour", Number(h2)).set("minute", Number(m2)).set("second", 0);
                              params = {
                                from: date1.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]"),
                                to: date2.utc().local().format("YYYY-MM-DDTHH:mm:ss[Z]")
                              };
                            }
                          }

                          if (!params) {
                            _context12.next = 9;
                            break;
                          }

                          // let's save the filter into orders module.
                          OrderModule.setDateOfVisitFilter({
                            params: params,
                            type: dateFilterType.value,
                            startDate: startDate.value,
                            startTime: startTime.value,
                            startDate2: startDate2.value,
                            startTime2: startTime2.value,
                            isAfterNow: afterNowFilter.value,
                            selectedDateShortcut: selectedDateShortcut.value
                          });
                          _context12.next = 7;
                          return getOrders();

                        case 7:
                          isFilterLoading.value = false;
                          drawerVisible.value = false;

                        case 9:
                        case "end":
                          return _context12.stop();
                      }
                    }
                  }, _callee12);
                }));
                return _updateDateFilter.apply(this, arguments);
              };

              updateDateFilter = function _updateDateFilter2() {
                return _updateDateFilter.apply(this, arguments);
              };

              goBack = function _goBack() {
                isOrderSelected.value = false;
              };

              formattedDate = function _formattedDate(date) {
                // date e.g: 2022-07-19T00:37:31+00:00
                // We will remove +00:00 from the string
                // because creating the date object out of the string as it was will convert it from utc to local timezone
                var localDateString = date.split("+")[0];
                var d = new Date(localDateString);

                if (d) {
                  var day = d.getDate() > 9 ? d.getDate() : "0" + String(d.getDate());
                  var month = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + String(d.getMonth() + 1);
                  return day + "." + month + ". " + d.getFullYear() + " " + (d.getHours() > 9 ? d.getHours() : "0" + d.getHours().toString()) + ":" + (d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes().toString());
                }

                return date;
              };

              queryOrders = function _queryOrders(event) {
                clearTimeout();
                setTimeout(function () {
                  bookingReferenceQuery.value = event === null || event === void 0 ? void 0 : event.target.value;
                }, 275);
              };

              _getFilter = function _getFilter3() {
                _getFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                  return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          _context11.t0 = parseFieldsResult;
                          _context11.next = 3;
                          return viewFilters();

                        case 3:
                          _context11.t1 = _context11.sent;
                          _context11.t2 = tableConfig();
                          return _context11.abrupt("return", (0, _context11.t0)(_context11.t1, _context11.t2));

                        case 6:
                        case "end":
                          return _context11.stop();
                      }
                    }
                  }, _callee11);
                }));
                return _getFilter.apply(this, arguments);
              };

              getFilter = function _getFilter2() {
                return _getFilter.apply(this, arguments);
              };

              getTableConfig = function _getTableConfig() {
                // it returns the table config from current user settings or from json file
                // const dataFromUserSettings = _get(this, "getAdvancedSettings.tables['completed-orders-booking'].columns", null);
                var dataFromUserSettings = UserModule.getAdvancedSettings.tables ? UserModule.getAdvancedSettings.tables["completed-orders-booking"].columns : null;
                var tableConfig = bookingsPaymentFilter.value === 0 ? completedTableConfig : bookingsPaymentFilter.value === 1 ? pendingTableConfig : completedTableConfig;
                return parseConfigPosition(tableConfig, dataFromUserSettings);
              };

              tableConfig = function _tableConfig() {
                return getTableConfig();
              };

              _getCurrentViewFilters = function _getCurrentViewFilter2() {
                _getCurrentViewFilters = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                  return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          return _context10.abrupt("return", _cloneDeep({
                            query: bookingReferenceQuery.value,
                            options: _objectSpread({
                              page: {
                                size: pageSize.value,
                                current: currentPage.value
                              },
                              filters: parseCurrentViewFilters(getViewConfig(), viewId
                              /* 'all' */
                              )
                            }, {
                              sort: _defineProperty({}, selectedSortingOption.value, selectedSortingDirection.value)
                            })
                          }));

                        case 1:
                        case "end":
                          return _context10.stop();
                      }
                    }
                  }, _callee10);
                }));
                return _getCurrentViewFilters.apply(this, arguments);
              };

              getCurrentViewFilters = function _getCurrentViewFilter() {
                return _getCurrentViewFilters.apply(this, arguments);
              };

              _viewFilters = function _viewFilters3() {
                _viewFilters = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                  var cvf;
                  return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return getCurrentViewFilters();

                        case 2:
                          cvf = _context9.sent;
                          return _context9.abrupt("return", cvf);

                        case 4:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));
                return _viewFilters.apply(this, arguments);
              };

              viewFilters = function _viewFilters2() {
                return _viewFilters.apply(this, arguments);
              };

              _updateBookingsPaymentFilter = function _updateBookingsPaymen2() {
                _updateBookingsPaymentFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(option) {
                  return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                      switch (_context8.prev = _context8.next) {
                        case 0:
                          bookingsPaymentFilter.value = option;

                        case 1:
                        case "end":
                          return _context8.stop();
                      }
                    }
                  }, _callee8);
                }));
                return _updateBookingsPaymentFilter.apply(this, arguments);
              };

              updateBookingsPaymentFilter = function _updateBookingsPaymen(_x) {
                return _updateBookingsPaymentFilter.apply(this, arguments);
              };

              setSortingDirection = function _setSortingDirection(value) {
                selectedSortingDirection.value = value;
              };

              getViewConfig = function _getViewConfig2() {
                // const publicViewConfig = _get(this, "getGroupOtherData.tables['completed-orders-booking'].views", null);
                // const privateViewConfig = _get(this, "getAdvancedSettings.tables['completed-orders-booking'].views", null);
                var publicViewConfig = UserModule.getGroupOtherData.tables && UserModule.getGroupOtherData.tables["completed-orders-booking"].views ? UserModule.getGroupOtherData.tables["completed-orders-booking"].views : null;
                var privateViewConfig = UserModule.getAdvancedSettings.tables && UserModule.getAdvancedSettings.tables["completed-orders-booking"].views ? UserModule.getAdvancedSettings.tables["completed-orders-booking"].views : null;
                var viewConfig = bookingsPaymentFilter.value === BookingPaymentOptions.Paid ? completedViewConfig : bookingsPaymentFilter.value === BookingPaymentOptions.NotPaid ? pendingViewConfig : allOrdersViewConfig;
                var params = {
                  defaultConfig: viewConfig,
                  publicConfig: publicViewConfig,
                  privateConfig: privateViewConfig
                };
                return parseViewsConfigs(params);
              };

              handleAllColumnsChange = function _handleAllColumnsChan(val) {
                var _iterator3 = _createForOfIteratorHelper(orderTableConfigCopy.value),
                    _step3;

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var item = _step3.value;
                    item.enabled = val;
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              };

              editIconStyle = "width: 30px; height: 30px";
              editIconContent = editPen;
              editIconAlt = "Edit";
              closeIconStyle = "width: 30px; height: 30px; filter: contrast(170%) invert(100%);";
              closeIconContent = closeIcon;
              closeIconAlt = "Close";
              leftArrowIconStyle = "width: 30px; height: 30px; filter: contrast(170%) invert(100%);";
              leftArrowIconContent = leftArrowIcon;
              leftArrowIconAlt = "Back";
              _useI18n = useI18n({}), t = _useI18n.t;
              dialogVisible = dialogVisibleForStatus(ModalStatus.Orders);
              bookingsPaymentFilter = ref(BookingPaymentOptions.All);
              query = ref("");
              pageSize = ref(10);
              currentPage = ref(1);
              bookingReferenceQuery = ref("");
              filter = ref(null);
              isOrderSelected = ref(false);
              isOrderViewLoaded = ref(false);
              selectedOrderId = ref("");
              selectedBookingRef = ref("");
              frameSource = ref("");
              frameHeight = ref("");
              drawerVisible = ref(false);
              drawerMode = ref();
              isFilterApplied = computed(function () {
                return !!OrderModule.dateOfVisitFilter || false;
              });
              dateFilter = computed(function () {
                return OrderModule.dateOfVisitFilter || null;
              });
              dateFilterType = ref(((_dateFilter$value = dateFilter.value) === null || _dateFilter$value === void 0 ? void 0 : _dateFilter$value.type) || OptionTypes.DateIs);
              selectedSortingOption = ref(OrderModule.selectedSortingOption);
              selectedSortingDirection = ref(OrderModule.selectedSortingDirection);
              startDate = ref(((_dateFilter$value2 = dateFilter.value) === null || _dateFilter$value2 === void 0 ? void 0 : _dateFilter$value2.startDate) || "");
              startTime = ref(((_dateFilter$value3 = dateFilter.value) === null || _dateFilter$value3 === void 0 ? void 0 : _dateFilter$value3.startTime) || "");
              startDate2 = ref(((_dateFilter$value4 = dateFilter.value) === null || _dateFilter$value4 === void 0 ? void 0 : _dateFilter$value4.startDate2) || "");
              startTime2 = ref(((_dateFilter$value5 = dateFilter.value) === null || _dateFilter$value5 === void 0 ? void 0 : _dateFilter$value5.startTime2) || "");
              dateFilterTypeOptions = [{
                name: t("filters.is"),
                value: OptionTypes.DateIs
              }, {
                name: t("filters.is-equal-to"),
                value: OptionTypes.DateEqualTo
              }, {
                name: t("filters.is-before"),
                value: OptionTypes.DateBefore
              }, {
                name: t("filters.is-after"),
                value: OptionTypes.DateAfter
              }, {
                name: t("filters.is-between"),
                value: OptionTypes.DateBetween
              }];
              dateShortcuts = [{
                label: t("select.today"),
                value: DatePeriod.Today
              }, {
                label: t("dashboards.yesterday"),
                value: DatePeriod.Yesterday
              }, {
                label: t("select.tomorrow"),
                value: DatePeriod.Tomorrow
              }];
              selectedDateShortcut = ref(((_dateFilter$value6 = dateFilter.value) === null || _dateFilter$value6 === void 0 ? void 0 : _dateFilter$value6.selectedDateShortcut) || DatePeriod.Today);
              isApllyFilterButtonEnabled = computed(function () {
                if (dateFilterType.value === OptionTypes.DateBetween && (!startDate.value || !startTime.value || !startDate2.value || !startTime2.value)) {
                  return false;
                } else if (dateFilterType.value === OptionTypes.DateAfter && !afterNowFilter.value && (!startDate.value || !startTime.value)) {
                  return false;
                } else if (dateFilterType.value !== OptionTypes.DateIs && dateFilterType.value !== OptionTypes.DateAfter && (!startDate.value || !startTime.value)) {
                  return false;
                }

                return true;
              });
              afterNowFilter = ref(((_dateFilter$value7 = dateFilter.value) === null || _dateFilter$value7 === void 0 ? void 0 : _dateFilter$value7.isAfterNow) || false);
              isFilterLoading = ref(false);
              showTicketsListModal = ref(false);
              ticketsList = ref([]);
              showRetailsListModal = ref(false);
              retailsList = ref([]);
              addonsList = ref({});
              isFetchingAddons = ref(false);
              orderAddonsList = ref([]);
              showAddonsListModal = ref(false);
              setOrderManagementTokens(".smeetz.com");
              watch(bookingsPaymentFilter, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return getFilter();

                      case 2:
                        filter.value = _context.sent;

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
              watch(bookingReferenceQuery, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return getFilter();

                      case 2:
                        filter.value = _context2.sent;

                      case 3:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })));
              watch(currentPage, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return getFilter();

                      case 2:
                        filter.value = _context3.sent;

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              })));
              watch(pageSize, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        _context4.next = 2;
                        return getFilter();

                      case 2:
                        filter.value = _context4.sent;

                      case 3:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              })));
              watch(selectedSortingOption, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        OrderModule.setSelectedSortingOption(selectedSortingOption.value);
                        _context5.next = 3;
                        return getFilter();

                      case 3:
                        filter.value = _context5.sent;

                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              })));
              watch(selectedSortingDirection, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        OrderModule.setSelectedSortingDirection(selectedSortingDirection.value);
                        _context6.next = 3;
                        return getFilter();

                      case 3:
                        filter.value = _context6.sent;

                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              })));
              watch(filter, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return getOrders();

                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7);
              })));
              _context16.next = 86;
              return getFilter();

            case 86:
              filter.value = _context16.sent;
              // await OrderModule.fetchBooking(parseFilter(filter.value));
              resultedBookings = ref(OrderModule.orders);
              parsedOrders = computed(function () {
                return OrderModule.getParsedOrders.map(function (data) {
                  var requireTeams = false;
                  var teamsStatus = BookingTeamsStatus.NotStarted;

                  try {
                    if (data.bookingTeamSetting && data.bookingTeamSetting.length) {
                      requireTeams = true;
                      var teams = data.bookingTeam.map(function (team) {
                        return JSON.parse(team);
                      }).filter(function (team) {
                        return !team.team_cancelled && team.team_room_players;
                      }) || [];

                      if (teams.length) {
                        var players = sumArray(teams.map(function (team) {
                          return Number(team.team_room_players);
                        }));
                        var countedPsp = data.bookingTeamSetting.map(function (s) {
                          return JSON.parse(s).team_setting_counted_psp;
                        }).flat().map(function (id) {
                          return Number(id);
                        });
                        var tickets = data.bookingTickets.map(function (pss) {
                          return JSON.parse(pss);
                        }).filter(function (pss) {
                          return pss.booking_status !== BookingStatus.Canceled && pss.booking_status !== BookingStatus.Abandoned && countedPsp.includes(Number(pss.price_id));
                        }) || [];

                        if (tickets.length > players) {
                          teamsStatus = BookingTeamsStatus.InProgress;
                        } else {
                          teamsStatus = BookingTeamsStatus.Completed;
                        }
                      }
                    }
                  } catch (error) {
                    console.log("error: ", error);
                  }

                  var bookingStartDates = [];

                  var _iterator = _createForOfIteratorHelper(data.bookingStartDates),
                      _step;

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var d = _step.value;
                      var parsed = JSON.parse(d); // we only keep the dates that match the current applied filter

                      if (parsed && isDateIncludedInFilter(parsed.start_date)) bookingStartDates.push({
                        date: formatDateTimeOrders(parsed.start_date),
                        quantity: Number(parsed.quantity_main)
                      });
                    } // data.bookingTickets array actually include retails
                    // Let's separate retails products from tickets products

                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  var retailProductIds = data.bookingProducts.filter(function (p) {
                    return p.includes("Retail");
                  }).map(function (p) {
                    return JSON.parse(p).id;
                  }) || [];
                  var bookingTickets = [];

                  var _iterator2 = _createForOfIteratorHelper(data.bookingTickets),
                      _step2;

                  try {
                    var _loop = function _loop() {
                      var t = _step2.value;
                      var parsed = JSON.parse(t); // Let's not show duplicates

                      if (!parsed || bookingTickets.findIndex(function (item) {
                        return item.id === parsed.id;
                      }) !== -1) {
                        return "continue";
                      }

                      if (!retailProductIds.includes(Number(parsed.product_id))) {
                        bookingTickets.push({
                          id: parsed.id,
                          name: parsed.name,
                          productName: parsed.product_name
                        });
                        return "continue";
                      }
                    };

                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var _ret = _loop();

                      if (_ret === "continue") continue;
                    } // For Retails we will not include any objet that is inside bookingTickets

                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  var bookingRetails = [];
                  var bookingTicketsIds = bookingTickets.map(function (i) {
                    return i.id;
                  }); // going to filter out tickets type tickets from the list of retails

                  for (var i = 0; i < data.bookingsTicketQuantity.length; i++) {
                    if (!bookingTicketsIds.includes(JSON.parse(data.bookingsTicketQuantity[i]).id)) {
                      bookingRetails.push(JSON.parse(data.bookingsTicketQuantity[i]));
                    }
                  }

                  return {
                    id: data.id,
                    reference: data.reference,
                    createdAt: formatDateTimeOrders(data.createdAt),
                    sellerFullName: data.sellerFullName,
                    totalValue: data.currency + " " + data.totalValue,
                    // bookingState: bs as string,
                    bookingPaymentStatus: t("orders.states.".concat(String(data.bookingPaymentStatus).toLowerCase())),
                    bookingSource: data.bookingSource,
                    customerFullName: data.customerFullName,
                    requireTeams: requireTeams,
                    teamsStatus: teamsStatus,
                    bookingChannel: data.bookingChannel && data.bookingChannel !== "null" ? t("orders.channel." + data.bookingChannel.split(" ").join("_")) : t("orders.channel.unkown"),
                    bookingTickets: bookingTickets,
                    bookingRetails: bookingRetails,
                    firstStartDate: formatDateTimeOrders(data.bookingFirstStartDate),
                    quantity: sumArray(bookingStartDates.map(function (d) {
                      return d.quantity;
                    }))
                  };
                });
              });
              ordersCount = computed(function () {
                return OrderModule.ordersCount;
              });
              orderTableConfig = computed(function () {
                return OrderModule.orderTableConfig;
              });
              orderTableConfigCopy = ref(cloneDeep(_toConsumableArray(OrderModule.orderTableConfig)));
              allColumnsEnabled = computed(function () {
                return orderTableConfigCopy.value.every(function (item) {
                  return item.enabled === true;
                });
              });
              isIndeterminate = computed(function () {
                // Check if the "Enable/Disable All" checkbox is in an indeterminate state
                var allEnabled = orderTableConfigCopy.value.some(function (item) {
                  return item.enabled;
                });
                var allDisabled = orderTableConfigCopy.value.some(function (item) {
                  return !item.enabled;
                });
                return allEnabled && allDisabled;
              });
              _getViewConfig = getViewConfig(), pinnedViewId = _getViewConfig.pinnedViewId;
              viewId = pinnedViewId; // eslint-disable-next-line

              // TODO @Hamza Show: Delivery Status
              columns = {
                reference: t("orders.booking-reference"),
                created_at: t("orders.creation-date"),
                seller_full_name: t("orders.seller"),
                total_value: t("orders.total-price"),
                booking_state: t("orders.payment-status"),
                customer_full_name: t("orders.customer-full-name")
              };

              changeCurrentPage = function changeCurrentPage(val) {
                currentPage.value = val;
              };
              /**
               * Takes a date in a string format and returns it as 31 Jan. 2020 13:00
               */


              groupId = computed(function () {
                return UserModule.getUserGroupId;
              });
              // we show the Teams column only for Fort Boyard and our testing groups
              showTeamsColumn = computed(function () {
                return POSConfigModule.groupId && [1, 16383
                /*DEV*/
                , 16342
                /*TEST*/
                , 19578, 19581, 19582, 19583, 19584, 19585, 19586, 19547
                /*Fort boyard*/
                ].includes(POSConfigModule.groupId);
              });
              return _context16.abrupt("return", {
                t: t,
                dialogVisible: dialogVisible,
                bookingsPaymentFilter: bookingsPaymentFilter,
                BookingPaymentOptions: BookingPaymentOptions,
                filter: filter,
                resultedBookings: resultedBookings,
                bookingReferenceQuery: bookingReferenceQuery,
                // queryBookings,
                updateBookingsPaymentFilter: updateBookingsPaymentFilter,
                parsedOrders: parsedOrders,
                columns: columns,
                formattedDate: formattedDate,
                BookingStateString: BookingStateString,
                ordersCount: ordersCount,
                changeCurrentPage: changeCurrentPage,
                pageSize: pageSize,
                currentPage: currentPage,
                queryOrders: queryOrders,
                isOrderSelected: isOrderSelected,
                isOrderViewLoaded: isOrderViewLoaded,
                selectedOrderId: selectedOrderId,
                selectedBookingRef: selectedBookingRef,
                groupId: groupId,
                frameSource: frameSource,
                frameHeight: frameHeight,
                goBack: goBack,
                closeIconStyle: closeIconStyle,
                closeIconContent: closeIconContent,
                closeIconAlt: closeIconAlt,
                leftArrowIconStyle: leftArrowIconStyle,
                leftArrowIconContent: leftArrowIconContent,
                leftArrowIconAlt: leftArrowIconAlt,
                editIconStyle: editIconStyle,
                editIconAlt: editIconAlt,
                editIconContent: editIconContent,
                BookingTeamsStatus: BookingTeamsStatus,
                showTeamsColumn: showTeamsColumn,
                updateDateFilter: updateDateFilter,
                startDate: startDate,
                startTime: startTime,
                startDate2: startDate2,
                startTime2: startTime2,
                dateFilterType: dateFilterType,
                dateShortcuts: dateShortcuts,
                selectedDateShortcut: selectedDateShortcut,
                dateFilterTypeOptions: dateFilterTypeOptions,
                OptionTypes: OptionTypes,
                isApllyFilterButtonEnabled: isApllyFilterButtonEnabled,
                isFilterApplied: isFilterApplied,
                toggleDrawer: toggleDrawer,
                SetUp: SetUp,
                Delete: Delete,
                clearDateFilter: clearDateFilter,
                getGroupDayJsDateFormat: getGroupDayJsDateFormat,
                selectedSortingOption: selectedSortingOption,
                selectedSortingDirection: selectedSortingDirection,
                CaretTop: CaretTop,
                CaretBottom: CaretBottom,
                setSortingDirection: setSortingDirection,
                SortingDirections: SortingDirections,
                showTicketsListModal: showTicketsListModal,
                ticketsList: ticketsList,
                showRetailsListModal: showRetailsListModal,
                retailsList: retailsList,
                afterNowFilter: afterNowFilter,
                addonsList: addonsList,
                isFetchingAddons: isFetchingAddons,
                showAddonsListModal: showAddonsListModal,
                orderAddonsList: orderAddonsList,
                orderTableConfig: orderTableConfig,
                Setting: Setting,
                DrawerModes: DrawerModes,
                drawerMode: drawerMode,
                drawerVisible: drawerVisible,
                OrderTableColumns: OrderTableColumns,
                isColumnEnabled: isColumnEnabled,
                orderTableConfigCopy: orderTableConfigCopy,
                updateOrderTableSettings: updateOrderTableSettings,
                isIndeterminate: isIndeterminate,
                allColumnsEnabled: allColumnsEnabled,
                handleAllColumnsChange: handleAllColumnsChange,
                selectOrderForEditing: selectOrderForEditing,
                isFilterLoading: isFilterLoading,
                close: close
              });

            case 101:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }))();
  },
  methods: {
    selectOrder: function selectOrder(row) {
      this.initListener();
      this.selectedOrderId = row.id;
      this.selectedBookingRef = row.reference;
      this.isOrderSelected = true;
      var bookingViewUrl = B2B_IFRAME_URL + "".concat(this.selectedBookingRef, "/overview?groupId=").concat(this.groupId, "&bookingId=").concat(this.selectedOrderId);
      LogService.info("Loading B2B app order view", {
        orderId: row.id,
        orderRef: row.reference,
        bookingViewUrl: bookingViewUrl
      });
      this.frameSource = bookingViewUrl;
      var windowHeight = window.innerHeight;
      this.frameHeight = "".concat(windowHeight - 20, "px"); // Lets decrease popup header size to 0

      var dialogHeader = getElementsByQuery(".orders > .el-overlay > .el-overlay-dialog > .el-dialog > .el-dialog__header")[0];
      dialogHeader.classList.add("nosize");
    },
    orderClick: function orderClick(row) {
      console.log("hi from orderClick, row: ", row); // Lets first check if the order that the user has clicked on is already in the localStorage
      // If it is, we will just open the order tab without repulling

      var bookingInState = BookingModule.bookingList.find(function (booking) {
        return booking.reference === row.reference;
      });

      if (bookingInState) {
        // We will manually select the booking just because the booking can be in the hidden bookings array
        console.log("going to manually select the booking");
        selectBooking(bookingInState.uuid, {
          fromMoreOrders: true
        }); // Lets open the order tab

        console.log("setting animation true");
        BookingModule.setTabAnimation(true); // lets now close orders table

        close();
        return;
      }

      this.selectOrderForEditing(row);
    },
    initListener: function initListener() {
      var _this = this;

      window.addEventListener("message", function (event) {
        if (event.data) {
          try {
            var data = JSON.parse(event.data);

            if (data.page === "order" && data.status === "LOADED") {
              _this.isOrderViewLoaded = true;
            }
          } catch (error) {
            throw new Error("Error when parsing event.data: " + event.data);
          }
        }
      }, {
        once: true
      });
    },
    openTicketsListModal: function openTicketsListModal(row) {
      this.ticketsList = row.bookingTickets;
      this.showTicketsListModal = true;
    },
    openRetailsListModal: function openRetailsListModal(row) {
      this.retailsList = row.bookingRetails;
      this.showRetailsListModal = true;
    },
    openAddonsListModal: function openAddonsListModal(id) {
      this.orderAddonsList = this.addonsList[id];
      this.showAddonsListModal = true;
    }
  }
});